import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=fd72c26a&scoped=true"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=fd72c26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd72c26a",
  null
  
)

export default component.exports